import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { cn } from "@/lib/utils";
import { PageHeader } from "@/components/shell/PageHeader";
import { Panel, ProvenanceTag, TableSkeleton } from "@/components/common/primitives";
import { UserPlus } from "lucide-react";
import { toast } from "sonner";

const ROLE_CLR = {
  owner: "bg-navy-900 text-ink-inverse",
  manager: "bg-signal-blue/10 text-signal-blue",
  analyst: "bg-emerald-100 text-emerald-600",
  viewer: "bg-surface-2 text-ink-secondary",
};

export function Team() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.team().then((r) => setRows(r.data));
  }, []);
  if (!rows) return <TableSkeleton rows={4} />;
  return (
    <div className="space-y-4">
      <PageHeader
        title="Team"
        description="Roles: owner, admin, manager, analyst, viewer, platform_admin. Enforced server-side with RLS."
        meta={<ProvenanceTag kind="fixture" />}
        actions={
          <button
            onClick={() => toast.success("Invitation sent (fixture)")}
            className="h-9 px-3 rounded-ctrl bg-signal-blue text-white text-compact flex items-center gap-1.5"
          >
            <UserPlus className="h-4 w-4" />
            Invite
          </button>
        }
      />
      <Panel className="p-0 overflow-hidden">
        <table className="w-full text-compact">
          <thead>
            <tr className="text-micro font-mono uppercase text-ink-muted text-left bg-surface-2">
              <th className="py-2 px-3">Member</th>
              <th className="px-3">Email</th>
              <th className="px-3">Role</th>
              <th className="px-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((u) => (
              <tr
                key={u.id}
                className="border-b border-edge-subtle last:border-0 hover:bg-surface-2"
              >
                <td className="py-2 px-3 text-ink-primary">{u.name}</td>
                <td className="px-3 font-mono text-micro">{u.email}</td>
                <td className="px-3">
                  <span
                    className={cn(
                      "text-micro font-mono px-1.5 py-0.5 rounded uppercase",
                      ROLE_CLR[u.role]
                    )}
                  >
                    {u.role}
                  </span>
                </td>
                <td className="px-3 text-micro font-mono uppercase text-ink-muted">
                  {u.status}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Panel>
    </div>
  );
}
